const confidence = [{
    value: 'No occlusion',
    label: 'No occlusion'
  },{
    value: 'Minor occlusion',
    label: 'Minor occlusion'
  },{
    value: 'Split occlusion',
    label: 'Split occlusion'
  },{
    value: 'End occlusion',
    label: 'End occlusion'
  },{
    value: 'Critical occlusion',
    label: 'Critical occlusion'
  }
]
export {confidence};
